import { Button } from "primereact/button";
import React, { useState } from "react";
import { Dialog } from "primereact/dialog";
import AddNewCompanyForm from "./AddNewCompanyForm";

function AddNewCompany({ getAllCompanies }) {
  const [showModal, setShowModal] = useState(false);

  const onCloseModal = () => {
    setShowModal(false);
  };
  return (
    <>
      <div className="Down__Btn">
        <Button
          onClick={() => setShowModal(true)}
          iconPos="right"
          label={"Add New Company"}
          className="Btn__Dark"
        />
      </div>
      <Dialog
        visible={showModal}
        style={{ width: "70vw" }}
        onHide={onCloseModal}
      >
        <AddNewCompanyForm
          onCloseModal={onCloseModal}
          getAllCompanies={getAllCompanies}
        />
      </Dialog>
    </>
  );
}

export default AddNewCompany;
